<template>
  <div>
  <div class="min-h-screen bg-darkblue p-4">
    <div class=" bg-white br-10 items-center mb-4 rounded-2xl " >
      <div class="w-full bg-divider  p-3 br-t-10 rounded-t-2xl">
        <span class="text-xxs font-semibold rounded-sm text-black text-center block">Tournament Winners</span>
      </div>
      <form @submit.prevent="submitForm">
        <div class="px-4 border-b border-divider">
          <span class="text-black text-opacity-50 text-sm my-4 block">Can you predict?</span>
          <div class="flex items-center mb-8" v-for="prediction in winner_player_predictions" :key="prediction.id">
            <div class="w-full">
              <span class="text-black  font-medium text-sm block leading-none mb-2">{{prediction.title}}</span>
              <multiselect :name="`${prediction.id}_player_winner`" :id="`${prediction.id}_player_winner`" class="custom-select br-10" v-model="form_data[prediction.id]"  track-by="id"  label="name" :options="players" placeholder="Select Player" @input="valueChange">
              </multiselect>
            </div>
          </div>
          <div class="flex items-center mb-8" v-for="prediction in winner_team_predictions" :key="prediction.id">
            <div class="w-full">
              <span class="text-black  font-medium text-sm block leading-none mb-2">{{prediction.title}}</span>
              <multiselect :name="`${prediction.id}_team_winner`" :id="`${prediction.id}_team_winner`" class="custom-select br-10" v-model="form_data[prediction.id]"  track-by="id"  label="name" :options="teams" placeholder="Select Team" @input="valueChange">
              </multiselect>
            </div>
          </div>
          <div class="flex items-center mb-8" v-for="prediction in winner_user_choice_predictions" :key="prediction.id">
            <div class="w-full">
              <span class="text-black  font-medium text-sm block leading-none mb-2">{{prediction.title}}</span>
              <multiselect :name="`${prediction.id}_customer_choice`" :id="`${prediction.id}_customer_choice`" class="custom-select br-10" v-model="form_data[prediction.id]"  track-by="id"  label="name" :options="user_choices" placeholder="Select" @input="valueChange">
              </multiselect>
            </div>
          </div>
        </div>
        <div class="p-4 pt-6">            
          <button type="submit" :class="`btn-login font-bold text-white w-full my-2 p-4 ${formInvalid()?'disabled':''}`" >Save</button>
        </div>
      </form>
    </div>
  </div>
  <Loader v-if="isLoading"/>
  </div>
</template>
<script type="text/javascript">
  import Loader from '../components/Loader.vue';
  import Multiselect from 'vue-multiselect';
  export default {
    components:{
      Loader,
      Multiselect
    },
    data() {
      return {
        isLoading:false,
        predictions:[],
        winner_player_predictions:[],
        winner_team_predictions:[],
        winner_user_choice_predictions: [],
        players:[],
        teams:[],
        user_choices: [],
        form_data:{},
        is_changed: false,
        contest_uuid:''
      }
    },
    async mounted(){
      this.contest_uuid = this.$route.params.uuid;
      this.isLoading = true;
      await this.fetchFormDetails();
      await this.fetchPredictions();
      this.isLoading = false;
    },
    methods:{
      async fetchFormDetails(){
        try{
          const res = await this.$axios.get(`/ipl/contests/${this.contest_uuid}/settings`);
          const match = res.data ? res.data: {};
          this.predictions = match.predictions ? match.predictions : [];
          this.winner_player_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "teamplayer");
          this.winner_team_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "team");
          this.winner_user_choice_predictions = this.predictions.filter(prediction => prediction.prediction_type.toLowerCase() === "userchoice");
          this.players = res.data.players ? res.data.players : [];
          this.teams = res.data.teams ? res.data.teams : [];
          this.user_choices = res.data.user_choices ? res.data.user_choices : [];
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async fetchPredictions(){
        try{
          const res = await this.$axios.get(`/ipl/contests/${this.contest_uuid}/prediction_detail`);
          const data = res.data;
          if(data && data.prediction && data.prediction.length > 0){
            for(let prediction of data.prediction){
              if(prediction.response_id){
                if(prediction.response_type.toLowerCase() === "team"){
                  this.form_data[prediction.prediction_criteria_id] = this.teams.find(team=> team.id === prediction.response_id);  
                }else{
                  if(prediction.response_type.toLowerCase() === "teamplayer"){
                    this.form_data[prediction.prediction_criteria_id] = this.players.find(score=>score.id === prediction.response_id);
                  }
                }
              }
            }
          }
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }
        }
      },
      async submitForm(){
        if(!this.form_data || Object.values(this.form_data).length === 0){
          this.$swal("Invalid","Please enter atleast one prediction","error");
          return;
        }

        if(!this.is_changed){
          this.$swal("Invalid","Please update your prediction","error");
          return;
        }

        const predictions = Object.keys(this.form_data).map(data=>{
          const prediction_field = this.predictions.find(prediction=>prediction.id === Number(data));
          return {
            criteria_id:Number(data),
            response_id:typeof this.form_data[data] === "object" ? this.form_data[data].id : this.form_data[data],
            response_type:prediction_field.prediction_type
          }
        });
        this.isLoading = true;
        try{
          const data = await this.$axios.post(`/ipl/contests/${this.contest_uuid}/predict`,{
            predictions:predictions
          });
          if(data && data.data && data.data.status){
            await this.$swal("Predictions","Success","success");
            this.$router.replace("/");
          }
          this.isLoading = false;
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Submit Failed",err.data.message,"error");
          }else{
            this.$swal("Submit Failed","Something went wrong!","error");
          }
          this.isLoading = false;
        }

      },
      getShortForm(name){
        return name ? name.split(" ").map(word=>word.trim()[0]).join(''):'';
      },
      formInvalid(){
        return (!this.form_data || Object.values(this.form_data).length === 0) || !this.is_changed;
      },
      valueChange(){
        this.$forceUpdate();
        console.log(this.form_data);
        this.is_changed = true;
      }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .custom-radio{
    line-height: 1;
  }
  .custom-radio span {
    background: #E6E6E6;
    box-shadow: inset 0px 4px 0px rgba(0, 0, 0, 0.06);
  }
  .custom-radio span i {
    font-style: normal;
  }
  .custom-radio span .text-8 {
    font-style: normal;
    font-size: 8px;
  }

  .custom-radio input:checked~span {
    color: #fff;
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
  }

  .btn-login {
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    -webkit-tap-highlight-color:transparent;
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }

  .btn-login.disabled{
    background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
    box-shadow: none;
  }
  .btn-login:active{
    outline: none;
    box-shadow: none;
  }
  .multiselect{
    @apply w-full border border-divider appearance-none focus:outline-none text-orange text-sm font-medium placeholder-black;
    box-sizing: border-box;
  }

</style>